// extracted by mini-css-extract-plugin
export default {"cls1":"ColladaOverlayCine-ThreeJsOverlay-module--cls1--SZedc","cls2":"ColladaOverlayCine-ThreeJsOverlay-module--cls2--OTQ9d ColladaOverlayCine-ThreeJsOverlay-module--cls1--SZedc"};